"use strict";

var _interopRequireDefault = require("D:/G/YT/mes-project-web/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("D:/G/YT/mes-project-web/node_modules/@babel/runtime/helpers/objectSpread2.js"));
var _toConsumableArray2 = _interopRequireDefault(require("D:/G/YT/mes-project-web/node_modules/@babel/runtime/helpers/toConsumableArray.js"));
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.array.find.js");
require("core-js/modules/es.array.join.js");
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.array.push.js");
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.filter.js");
require("core-js/modules/es.iterator.find.js");
require("core-js/modules/es.iterator.for-each.js");
require("core-js/modules/es.iterator.map.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/web.dom-collections.for-each.js");
var _mixins = _interopRequireDefault(require("./mixins"));
var _dataGrid = require("@/utils/dataGrid");
var _default = exports.default = {
  /** 当前组件的名字
   * 默认使用 父组件引入该组件时使用的标签名
   * 如果设置了 name 那么会优先使用这个名字
   * 如果父组件引入该组件，并在引入的组件标签上 增加 name 属性，那么将回使用这个名字，优先级最高。
   */
  name: 'wl-drawer-search',
  /* 混入 */
  mixins: _mixins.default,
  /** 父组件引入子组件，并在子组件上设置的属性，都会在这个地方接收
   * 如果这个地方没有与父组件设置的属性名字相同的参数，那么这个值将无法在该组件中使用
   * 例如父组件 openType 属性，该props中应有一个 openType ，这样子组件就能使用父组件传递过来的 openType 。
   * */
  props: {},
  /* 当前组件的数据源，在这里定义的数据不能与 props 名相同，会冲突 */data: function data() {
    return {
      drawer: {
        show: false
      },
      defaultValue: '',
      placeholder: '',
      formOption: {
        'label-width': '120px',
        'label-position': 'right'
      }
    };
  },
  /* 过滤器 */
  filters: {},
  /* 计算属性 */
  computed: {
    getCanQuery: function getCanQuery() {
      return this.query.filter(function (item) {
        return item.type !== 'static' && item.label;
      });
    }
  },
  /* 数据监听 */
  watch: {
    queryValue: {
      handler: function handler(nv) {
        this.defaultValue = nv;
      }
    },
    defaultValue: {
      handler: function handler(nv, ov) {
        this.$emit('update:query-value', nv, ov);
      }
    }
  },
  /* 方法 当前组件可使用的方法 */
  methods: {
    /**
     * @description: 组件初始化
     * @return { void }
     */
    init: function init() {
      this.setDefaultQuery();
    },
    /**
     * @description: 设置 组件默认查询条件，也就是显示在输入框里的查询条件
     * @return { void }
     */
    setDefaultQuery: function setDefaultQuery() {
      this.placeholder = this.query.filter(function (item) {
        return item.default && item.code;
      }).map(function (item) {
        return item.label;
      }).join('、');
    },
    getAllQuery: function getAllQuery() {
      var _this$$refs$wlFormC, _this$$refs$wlFormC2;
      // const a = Array.isArray(this.query) ? [...this.query] : []
      var a = (_this$$refs$wlFormC = (_this$$refs$wlFormC2 = this.$refs['wl-form-control']) === null || _this$$refs$wlFormC2 === void 0 ? void 0 : _this$$refs$wlFormC2.getValue()) !== null && _this$$refs$wlFormC !== void 0 ? _this$$refs$wlFormC : this.query;
      var querys = (0, _toConsumableArray2.default)(a);
      this.query.filter(function (item) {
        return item.required;
      }).forEach(function (q1) {
        var b = querys.find(function (q2) {
          return q2.code === q1.code;
        });
        if (!b) querys.push(q1);else Object.assign(b, q1);
      });
      return querys;
    },
    /**
     * @description: 获取 查询条件
     * @return { Object } 查询条件
     */
    getQueryCondition: function getQueryCondition() {
      var _this = this;
      var querys = this.getAllQuery();
      var queryAdd = [];
      querys.map(function (item) {
        var _item$defaultValue;
        var r1 = typeof item.value === 'string' && item.value === '';
        var r2 = typeof item.value !== 'string' && _this.$$isEmpty(item.value);
        if (r1 || r2 && _this.$$isNoEmpty(item.defaultValue)) item.value = (_item$defaultValue = item.defaultValue) !== null && _item$defaultValue !== void 0 ? _item$defaultValue : '';
        return item;
      }).forEach(function (item) {
        var _ref, _item$is, _item$control;
        var is = (_ref = (_item$is = item.is) !== null && _item$is !== void 0 ? _item$is : (_item$control = item.control) === null || _item$control === void 0 ? void 0 : _item$control.is) !== null && _ref !== void 0 ? _ref : '';
        var a = ['el-date-picker', 'el-time-picker'].indexOf(is) > -1;
        var b = Array.isArray(item.value);
        if (a && b) {
          var _item$sqlExp;
          var exp = (_item$sqlExp = item.sqlExp) !== null && _item$sqlExp !== void 0 ? _item$sqlExp : ['>=', '<='];
          item.value.forEach(function (v, i) {
            var _exp$i;
            queryAdd.push((0, _objectSpread2.default)((0, _objectSpread2.default)((0, _objectSpread2.default)({}, item), {}, {
              value: v,
              sqlExp: (_exp$i = exp[i]) !== null && _exp$i !== void 0 ? _exp$i : '='
            }, Array.isArray(item.column) ? {
              column: item.column[i]
            } : {}), Array.isArray(item.dbColumn) ? {
              dbColumn: item.dbColumn[i]
            } : {}));
          });
        } else {
          queryAdd.push((0, _objectSpread2.default)({}, item));
        }
      });
      var condition = (0, _dataGrid.getAdvanceParams)(queryAdd, this.defaultValue);
      return condition;
    },
    /**
     * @description: 事件 查询
     * @return { void }
     */
    onQuery: function onQuery() {
      var _this$$parent$getRef;
      (_this$$parent$getRef = this.$parent.getRef('table-main')) === null || _this$$parent$getRef === void 0 || _this$$parent$getRef.setPagination({
        currentPage: 1
      });
      var querys = this.getAllQuery();
      var queryValue = querys.map(function (_ref2) {
        var code = _ref2.code,
          value = _ref2.value;
        return {
          code: code,
          value: value
        };
      });
      var condition = this.getQueryCondition();
      this.$$listenersEmit('on-query', condition, queryValue, querys, _dataGrid.getAdvanceParams);
    },
    /**
     * @description: 事件 重置查询条件
     * @return { void }
     */
    resetSearch: function resetSearch() {
      var _this$$parent$getRef2, _this$$refs$wlFormC3;
      (_this$$parent$getRef2 = this.$parent.getRef('table-main')) === null || _this$$parent$getRef2 === void 0 || _this$$parent$getRef2.setPagination({
        currentPage: 1
      });
      (_this$$refs$wlFormC3 = this.$refs['wl-form-control']) === null || _this$$refs$wlFormC3 === void 0 || _this$$refs$wlFormC3.resetValue();
      this.defaultValue = '';
      this.query.filter(function (item) {
        return !item.required;
      }).map(function (item) {
        return Object.assign(item, {
          value: ''
        });
      });

      // this.onQuery()
      this.$$listenersEmit('reset-search', this.query.map(function (_ref3) {
        var code = _ref3.code,
          value = _ref3.value;
        return {
          code: code,
          value: value
        };
      }));
    }
  },
  /* 以下 Vue 的生命周期，皆按照顺序执行，注意看执行触发的时间 */created: function created() {
    this.init();
  },
  mounted: function mounted() {},
  beforeUpdate: function beforeUpdate() {
    this.setDefaultQuery();
  }
};